<script lang="ts">
	import { Device } from "luxedo-data"
	import { viewDevice } from "../../../../modules/page-events/navigator"

	import * as css from "./UserRow.module.css"

	interface Props {
		devices: Array<Device>;
	}

	let { devices }: Props = $props();

	function onDeviceClick(device: Device) {
		viewDevice(device)
	}
</script>

<div class={css.info}>
	<h2>Devices</h2>
	{#if devices}
		<table>
			<thead>
				<tr>
					<th>ID</th>
					<th>Name</th>
					<th>Type</th>
				</tr>
			</thead>
			<tbody>
				{#each devices as device}
					{#if device}
						<tr class={css.row} onclick={() => onDeviceClick(device)} role="button" tabindex="0">
							<td>
								{device.id}
							</td>
							<td>
								{device.name}
							</td>
							<td>
								{Device.getDeviceTypeName(device.typeId)}
							</td>
						</tr>
					{/if}
				{/each}
			</tbody>
		</table>
	{/if}
</div>

<style>
</style>
